var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31689_699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 6.66667V10.8333C13.3327 11.4964 13.5961 12.1323 14.0649 12.6011C14.5338 13.0699 15.1697 13.3333 15.8327 13.3333C16.4957 13.3333 17.1316 13.0699 17.6005 12.6011C18.0693 12.1323 18.3327 11.4964 18.3327 10.8333V10C18.3326 8.11919 17.6962 6.29373 16.5271 4.82044C15.358 3.34715 13.7248 2.31269 11.8932 1.88525C10.0616 1.45781 8.1393 1.66253 6.43881 2.46614C4.73832 3.26974 3.35969 4.62496 2.52707 6.31144C1.69446 7.99791 1.45683 9.91645 1.85283 11.7551C2.24883 13.5937 3.25517 15.2444 4.70821 16.4386C6.16126 17.6328 7.97555 18.3003 9.85608 18.3326C11.7366 18.365 13.5728 17.7602 15.066 16.6167M13.3327 10C13.3327 11.8409 11.8403 13.3333 9.99936 13.3333C8.15841 13.3333 6.66603 11.8409 6.66603 10C6.66603 8.15905 8.15841 6.66667 9.99936 6.66667C11.8403 6.66667 13.3327 8.15905 13.3327 10Z",
    stroke: "#7B7B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31689_699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSign);
export default __webpack_public_path__ + "static/media/email-sign.30e2d4acc028a014f608b159499047e1.svg";
export { ForwardRef as ReactComponent };